import { useState, useEffect } from 'react';
import { validSplitGroups } from './utils';

export const useSplitGroupsValidation = (splitGroups, evenlyDistribute) => {
  const [isValid, setIsValid] = useState(validSplitGroups(splitGroups));

  useEffect(() => {
    const valid = validSplitGroups(splitGroups);
    setIsValid(valid);
  }, [evenlyDistribute, splitGroups]);
  return isValid;
};
